import React from 'react'
import { FormattedMessage } from 'react-intl'
import { BLink } from '@prague-digi/ui-components'

import messages from '../../../i18n'

import styles from './styles.scss'
import pdfIcon from '../../../assets/pdf.svg'

interface Props {
  fileName: string
  remove: () => void
}

const FileInfo: React.FunctionComponent<Props> = (props: Props) => (
  <div className={styles.fileInfo}>
    <img src={pdfIcon} alt="" className={styles.fileIcon} />
    <div className={styles.fileName}>{props.fileName}</div>
    <BLink onClick={props.remove} theme={styles.removeLink}>
      <FormattedMessage {...messages.popUpload.remove} />
    </BLink>
  </div>
)

export default FileInfo
